import * as React from 'react';
import UserTable from './UserTable';

function UserManagement() {
  return (
    <div>
      <UserTable />
    </div>
  );
}

export default UserManagement;
